var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgSettings = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      id: "Group_17016",
      "data-name": "Group 17016",
      width: 25,
      height: 25.672,
      viewBox: "0 0 25 25.672",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_11431",
      "data-name": "Path 11431",
      d: "M5801.571,783.649l-2.359-1.845a8.632,8.632,0,0,0,0-1.938l2.361-1.846a1.156,1.156,0,0,0,.279-1.475L5799.4,772.3a1.159,1.159,0,0,0-1.418-.511l-2.782,1.119a9.475,9.475,0,0,0-1.67-.97l-.427-2.954a1.137,1.137,0,0,0-1.136-.984h-4.92a1.134,1.134,0,0,0-1.13.976l-.427,2.963a9.843,9.843,0,0,0-1.668.971l-2.789-1.121a1.138,1.138,0,0,0-1.41.5l-2.457,4.251a1.148,1.148,0,0,0,.279,1.481l2.36,1.845a8.521,8.521,0,0,0,0,1.938l-2.361,1.845a1.157,1.157,0,0,0-.281,1.475l2.454,4.244a1.159,1.159,0,0,0,1.419.511l2.781-1.119a9.532,9.532,0,0,0,1.672.971l.427,2.952a1.136,1.136,0,0,0,1.13.985h4.92a1.136,1.136,0,0,0,1.134-.975l.427-2.963a9.908,9.908,0,0,0,1.669-.971l2.792,1.122a1.138,1.138,0,0,0,1.409-.5l2.465-4.268A1.155,1.155,0,0,0,5801.571,783.649Zm-12.068,2.535a5.348,5.348,0,1,1,5.348-5.348A5.348,5.348,0,0,1,5789.5,786.184Z",
      transform: "translate(-5777.004 -768)"
    })))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Settings.1d5c5337.svg";
export { ForwardRef as ReactComponent };